export const deliveryMap = () => {
  const deliveryMapElement = document.querySelector(`.js-delivery-map`);

  if (deliveryMapElement) {
    let pvz = {
      myMapGlobal: {},
      grastin: [],
      sdek: [],
      grastinClasterArr: [],
      sdekClasterArr: [],
      grastinClasterObj: [],
      sdekClasterObj: [],
    };
    window.pvz = pvz;

    // вспомогательные функции
    function stringToBoolean(str) {
      if (String(str).toLowerCase() == `true` || String(str).toLowerCase() == `1`) {
        return true;
      }
      if (String(str).toLowerCase() == `false` || String(str).toLowerCase() == `0`) {
        return false;
      }
      return null;
    }

    // 3. созданите меток
    function setGrastin(arr, myMap) {
      arr.forEach((point) => {
        let item = {
          drivingdescription: point["drivingdescription"] ? point["drivingdescription"] : "",
          linkdrivingdescription: point["linkdrivingdescription"], //url to img
          latitude: +point["latitude"],
          longitude: +point["longitude"],
          id: point["id"],
          city: point["city"],
          phone: point["phone"],
          email: point["email"],
          timetable: point["timetable"],
          title: "Грастин, " + point["title"],
          metrostation: point["metrostation"],
          paymentcard: stringToBoolean(point["paymentcard"]),
          regional: stringToBoolean(point["regional"]),
          largesize: stringToBoolean(point["largesize"]),
          onlylargesize: stringToBoolean(point["onlylargesize"]),
          dressingroom: stringToBoolean(point["dressingroom"]),
          deliveryregion: point["deliveryregion"],
          Exchange: stringToBoolean(point["Exchange"]),
          TakeAway: stringToBoolean(point["TakeAway"]),
          address: point["address"],
          weightMax: point["weightMax"],
          lengthSideMax: point["lengthSideMax"],
          sumSidesMax: point["sumSidesMax"],
          type: `grastin`,
          coord: [+point["latitude"], +point["longitude"]],
        };

        pvz.grastin.push(item);

        let myPlacemark = new ymaps.Placemark(
          item.coord,
          {
            balloonContentHeader: item.title,
            balloonContent: `<p>Адрес: ${item.address}</p>`,
          },
          {
            preset: "islands#circleDotIcon",
            iconColor: "#ff3b83",
          },
        );

        pvz.grastinClasterArr.push(myPlacemark);
      });

      let myGeoObjects = pvz.grastinClasterArr;
      let myClustererGrastin = new ymaps.Clusterer({
        preset: "islands#pinkClusterIcons",
        clusterHideIconOnBalloonOpen: false,
        geoObjectHideIconOnBalloonOpen: false,
      });
      myClustererGrastin.add(myGeoObjects);
      myMap.geoObjects.add(myClustererGrastin);

      pvz.grastinClasterObj = myClustererGrastin;
    }

    function setSdek(arr, myMap) {
      arr.forEach((point) => {
        let item = {
          latitude: +point["location"]["latitude"],
          longitude: +point["location"]["longitude"],
          id: point["code"],
          phone: `${point["phones"] ? point["phones"][0]["number"] : ""}`,
          email: point["email"],
          title: `СДЭК, ${point["code"]}: ${point["name"]}`,
          address_full: point["location"]["address_full"],
          address_comment: point["address_comment"] ? point["address_comment"] : "",
          work_time: point["work_time"],
          type: `sdek`,
          coord: [+point["location"]["latitude"], +point["location"]["longitude"]],
        };

        pvz.sdek.push(item);

        let myPlacemark = new ymaps.Placemark(
          item.coord,
          {
            balloonContentHeader: item.title,
            balloonContent: `<p>Адрес: ${item.address_full}</p>`,
          },
          {
            preset: "islands#circleDotIcon",
            iconColor: "#00a942",
          },
        );

        pvz.sdekClasterArr.push(myPlacemark);
      });

      let myGeoObjects = pvz.sdekClasterArr;
      let myClustererSdek = new ymaps.Clusterer({
        preset: "islands#darkGreenClusterIcons",
        clusterHideIconOnBalloonOpen: false,
        geoObjectHideIconOnBalloonOpen: false,
      });
      myClustererSdek.add(myGeoObjects);
      myMap.geoObjects.add(myClustererSdek);

      pvz.sdekClasterObj = myClustererSdek;
    }

    // 2. получение данных из файлов
    let prefix = "";
    function getJsonData(myMap) {
      // let promiseGrastin = fetch(prefix + '/grastin.json');
      let promiseSdek = fetch(prefix + "/sdek.json");

      Promise.all([promiseSdek]).then((responses) => responses.forEach((response) => response.json().then((obj) => setSdek(obj, myMap))));
    }

    // 1. создание карты
    ymaps.ready(init);

    const getZoom = () => {
      if (window.matchMedia("(max-width: 767px)").matches) {
        return 2;
      }

      return 4;
    };

    function init() {
      let zoom = getZoom();
      let center = [54.901171, 52.29723];
      let placemark;

      let myMap = new ymaps.Map(
        "deliveryMap",
        {
          center: center,
          zoom: zoom,
        },
        (placemark = new ymaps.Placemark(
          [59.921962, 30.416875],
          {
            balloonContentHeader: `Наш офис`,
            balloonContent: "<p>Адрес: Россия, Санкт-Петербург, наб. Канала Грибоедова, д.59</p>",
          },
          {
            iconLayout: "default#image",
            iconImageHref: "/img/contacts/tezis-map-icon.svg",
            iconImageSize: [60, 84],
            iconImageOffset: [-40, -84],
          },
        )),
      );

      myMap.geoObjects.add(placemark);
      pvz.myMapGlobal = myMap;

      getJsonData(myMap);
    }

    // дополнительно: фильтрация кластеров меток
    function pvzFilter() {
      let radioElList = Array.from(document.querySelectorAll(".js-pvz-filter-radio"));

      function setFilterGrastin() {
        removeAll();
        pvz.grastinClasterObj.add(pvz.grastinClasterArr);
      }

      function setFilterSdek() {
        removeAll();
        pvz.sdekClasterObj.add(pvz.sdekClasterArr);
      }

      function setFilterAll() {
        removeAll();
        pvz.grastinClasterObj.add(pvz.grastinClasterArr);
        pvz.sdekClasterObj.add(pvz.sdekClasterArr);
      }

      function removeAll() {
        pvz.grastinClasterObj.removeAll();
        pvz.sdekClasterObj.removeAll();
      }

      radioElList.forEach((radioEl) => {
        radioEl.addEventListener("change", (e) => {
          //какой то глюк не дает написать в value просто sdek
          let pvzAlias = radioEl.value.split("-")[0];

          switch (pvzAlias) {
            case "grastin":
              setFilterGrastin();
              break;
            case "sdek":
              setFilterSdek();
              break;
            default:
              setFilterAll();
              break;
          }
        });
      });
    }
    pvzFilter();
  }
};
